import { render, staticRenderFns } from "./TopBanner.vue?vue&type=template&id=a8e1ca2c&"
import script from "./TopBanner.js?vue&type=script&lang=js&"
export * from "./TopBanner.js?vue&type=script&lang=js&"
import style0 from "./TopBanner.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports